// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"522":"98ec4cde","757":"f40b80f7"}[chunkId] + ".css";
};